import { $api, invalidateTypedQueries } from '@/api/typedClient'
import { useQueryClient } from '@tanstack/react-query'

/**
 * Hook to accept an order change request.
 * Does not auto-invalidate on success - returns order_row for direct cache update.
 */
export function useAcceptOrderChange() {
  const queryClient = useQueryClient()

  const mutation = $api.useMutation('post', '/crossroads/order/change/accept')

  /** The grid owns its rows, so the caller writes the returned row straight
   * into it -- only the history needs refetching once the status changed. */
  const invalidateHistory = () =>
    invalidateTypedQueries(
      queryClient,
      'post',
      '/crossroads/order/change/history',
    )

  return {
    ...mutation,
    invalidateHistory,
  }
}

/**
 * Hook to reject an order change request.
 * Does not auto-invalidate on success - returns order_row for direct cache update.
 */
export function useRejectOrderChange() {
  const queryClient = useQueryClient()

  const mutation = $api.useMutation('post', '/crossroads/order/change/reject')

  /** The grid owns its rows, so the caller writes the returned row straight
   * into it -- only the history needs refetching once the status changed. */
  const invalidateHistory = () =>
    invalidateTypedQueries(
      queryClient,
      'post',
      '/crossroads/order/change/history',
    )

  return {
    ...mutation,
    invalidateHistory,
  }
}
